import {Radio} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import type {ISelectOption} from 'src/types/Form';

export interface FormRadioGroupProps {
  label: string;
  id?: string;
  value?: string | number;
  options: ISelectOption[];
  disabled?: boolean;
  row?: boolean;
  helpText?: string;
  onChange: (value: string) => void;
}
export const FormRadioGroup = ({
  label,
  id,
  value,
  options,
  disabled,
  helpText,
  row = true,
  onChange,
}: FormRadioGroupProps) => {
  const Layout = row ? Group : Stack;

  return (
    <Radio.Group
      id={id}
      label={label}
      description={helpText}
      value={value !== undefined ? String(value) : undefined}
      onChange={onChange}
      mb="md">
      <Layout mt="xs">
        {options.map(option => (
          <Radio
            key={option.id}
            value={String(option.id)}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </Layout>
    </Radio.Group>
  );
};
